import type { BuscaLista, PeriodoFunil } from './tipos';

/** Janela padrao do funil: orcamentos criados nos ultimos N dias (S36-D5). */
export const DIAS_PERIODO_FUNIL = 60;
export const PERIODO_PADRAO_FUNIL: PeriodoFunil = 'ULTIMOS_60';
/** Chave do localStorage com a ultima escolha do usuario (lembrada entre visitas). */
export const CHAVE_PERIODO_FUNIL = 'triade.funil.periodo';

/** Escolha lembrada do usuario; sem escolha, sem armazenamento ou com valor invalido, vale o padrao. Nunca lanca. */
export function lerPeriodoLembrado(): PeriodoFunil {
  try {
    const valor = window.localStorage.getItem(CHAVE_PERIODO_FUNIL);
    return valor === 'TODOS' || valor === 'ULTIMOS_60' ? valor : PERIODO_PADRAO_FUNIL;
  } catch {
    return PERIODO_PADRAO_FUNIL;
  }
}

/** Grava a escolha do usuario. Sem armazenamento (modo privado, bloqueio), a escolha vale so nesta visita. Nunca lanca. */
export function gravarPeriodoLembrado(periodo: PeriodoFunil): void {
  try {
    window.localStorage.setItem(CHAVE_PERIODO_FUNIL, periodo);
  } catch {
    // sem armazenamento: nada a fazer
  }
}

/** Data ISO (AAAA-MM-DD) de N dias atras, pelo calendario local. Data, nao valor: nenhuma conta de preco, custo ou margem. */
export function dataDeUltimosDias(dias: number, hoje: Date = new Date()): string {
  const d = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - dias);
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mes}-${dia}`;
}

/**
 * Aplica o periodo do funil a busca: nos ultimos N dias pela data de criacao do orcamento (`dataDe`). Um periodo de data
 * escolhido na propria URL (`dataDe`) vale mais que o padrao; "todos" nao filtra por data.
 */
export function buscaComPeriodo(busca: BuscaLista, periodo: PeriodoFunil, hoje?: Date): BuscaLista {
  if (periodo === 'TODOS' || busca.dataDe) return busca;
  return { ...busca, dataDe: dataDeUltimosDias(DIAS_PERIODO_FUNIL, hoje) };
}
